import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';

import { TransactionFilterKey } from 'support/types/filterKeys';
import { FilterValue } from 'support/types/filters';
import { Button } from 'components/Form/Button';

import { useImportableIntegrations } from '../../hooks/useImportableIntegrations';
import { ImportDocumentsModal } from '../ImportDocumentsModal/ImportDocumentsModal';

type ImportDocumentsButtonProps = {
  filterValues: Array<FilterValue>;
};

/**
 * Header affordance (TOOL-2054): always available whenever the current partner has at least one
 * Xentral integration ready to import from. The modal picks the source system + document type, so
 * no list filters are required — but when the list is narrowed to a single document number we
 * pre-fill it to keep the "I searched for it, it's not here, pull it" flow one step.
 */
export const ImportDocumentsButton = ({ filterValues }: ImportDocumentsButtonProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const importableIntegrations = useImportableIntegrations();

  if (importableIntegrations.length === 0) {
    return null;
  }

  const searchedDocumentNumber = filterValues
    .find((filter) => filter.key === TransactionFilterKey.transactionId)
    ?.value?.trim();
  const prefill = searchedDocumentNumber ? [searchedDocumentNumber] : undefined;

  return (
    <>
      <Button
        analyticsId="transactions:import_documents"
        variant="secondary"
        size="base"
        LeftIcon={ArrowUpTrayIcon}
        onClick={() => setOpen(true)}
      >
        {t('transactions:list.importDocuments.cta')}
      </Button>
      {open && <ImportDocumentsModal open={open} setOpen={setOpen} prefill={prefill} />}
    </>
  );
};
